import {FC, useEffect, useState, ReactNode} from 'react'

import {createPortal} from 'react-dom'

interface IPortalProps {
	children: ReactNode
}

const Portal: FC<IPortalProps> = ({children}) => {
	const [isMounted, setIsMounted] = useState(false)

	useEffect(() => {
		setIsMounted(true)

		return () => setIsMounted(false)
	}, [])
	return isMounted ? createPortal(children, document.querySelector('#portals') as Element) : null
}

Portal.displayName = 'Portal'

export default Portal
